import { render, staticRenderFns } from "./PopupRejectedRequests.vue?vue&type=template&id=556e7260&scoped=true&"
import script from "./PopupRejectedRequests.vue?vue&type=script&lang=js&"
export * from "./PopupRejectedRequests.vue?vue&type=script&lang=js&"
import style0 from "./PopupRejectedRequests.vue?vue&type=style&index=0&id=556e7260&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556e7260",
  null
  
)

export default component.exports